import { render, staticRenderFns } from "./DialogOpcionesConsulta.vue?vue&type=template&id=85cb6a0c&scoped=true&"
import script from "./DialogOpcionesConsulta.vue?vue&type=script&lang=js&"
export * from "./DialogOpcionesConsulta.vue?vue&type=script&lang=js&"
import style0 from "./DialogOpcionesConsulta.vue?vue&type=style&index=0&id=85cb6a0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb6a0c",
  null
  
)

export default component.exports